import { TODO_ITEM_TEMPLATE_PLACEHOLDER } from "../helpers/constants"

export const TODO_ITEM_TEMPLATE = `<li class="flex" data-done data-type="todo_item">
  <label>
    <input type="checkbox" checked="checked" />
  </label>
  <div><p>${TODO_ITEM_TEMPLATE_PLACEHOLDER}</p></div>
</li>`
